(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["artwork-enhancements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('artwork-product-enhancements')) {
  customElements.define('artwork-product-enhancements', class extends HTMLElement {
    connectedCallback() {
      this.product = document.getElementById(`MainProduct-${this.dataset.section}`);
      if (!this.product || this.started) return;
      this.started = true;
      this.bar = this.querySelector('.artwork-preview__sticky');
      this.button = this.querySelector('[data-artwork-add]');
      this.price = this.querySelector('[data-artwork-price]');
      this.selection = this.querySelector('[data-artwork-selection]');
      this.nativeButton = this.product.querySelector(`#ProductSubmitButton-${this.dataset.section}`);
      if (!this.nativeButton) return;
      this.optionsReached = false;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.onMedia = () => this.updateVisibility();
      this.mobile.addEventListener('change', this.onMedia);
      this.button.addEventListener('click', () => {
        if (this.button.disabled || this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true') return;
        this.nativeButton.click();
      });
      this.offerButton = this.product.querySelector('[data-artwork-offer]');
      this.offerButton?.addEventListener('click', () => this.nativeOffer?.click());
      this.onChange = (event) => {
        if (event.target.closest('variant-selects')) {
          this.openGuides = Array.from(this.product.querySelectorAll('[data-artwork-guide][open]')).map(node => node.dataset.artworkGuide);
          this.optionsReached = true;
          this.button.disabled = true;
          this.selection.textContent = this.dataset.pending;
          this.price.textContent = '';
          this.pending = true;
        }
      };
      this.product.addEventListener('change', this.onChange);
      this.formObserver = new MutationObserver(() => this.scheduleSync());
      this.formObserver.observe(this.nativeButton, { attributes: true, childList: true, subtree: true });
      const nativePrice = this.product.querySelector(`#price-${this.dataset.section}`);
      if (nativePrice) this.formObserver.observe(nativePrice, { attributes: true, childList: true, subtree: true });
      this.offVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        this.pending = false;
        this.sync();
      });
      this.offError = subscribe(PUB_SUB_EVENTS.cartError, () => {
        this.nativeButton.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
      this.intersection = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === this.nativeButton) this.nativeVisible = entry.isIntersecting;
          if (entry.target === this.product.querySelector('.product__title') && entry.boundingClientRect.bottom < 0) this.optionsReached = true;
        }
        this.updateVisibility();
      });
      this.intersection.observe(this.nativeButton);
      this.intersection.observe(this.product.querySelector('.product__title'));
      this.offerObserver = new MutationObserver((entries) => {
        if (!entries.some(entry => entry.addedNodes.length || entry.removedNodes.length)) return;
        if (this.offerFrame) return;
        this.offerFrame = requestAnimationFrame(() => { this.offerFrame = null; this.findOffer(); this.updateVisibility(); });
      });
      this.offerObserver.observe(document.body, { childList: true, subtree: true });
      this.findOffer();
      this.sync();
    }
    scheduleSync() {
      if (this.syncFrame) return;
      this.syncFrame = requestAnimationFrame(() => { this.syncFrame = null; this.sync(); });
    }
    sync() {
      const selected = this.product.querySelector('variant-selects [data-selected-variant]');
      let variant;
      try { variant = JSON.parse(selected?.textContent || 'null'); } catch { variant = null; }
      const unavailable = this.nativeButton.disabled && this.nativeButton.textContent.trim() === window.variantStrings.unavailable;
      if (unavailable) this.pending = false;
      const busy = this.nativeButton.getAttribute('aria-disabled') === 'true' || this.nativeButton.classList.contains('loading');
      this.button.disabled = this.pending || this.nativeButton.disabled || busy || !variant?.available;
      this.button.textContent = this.nativeButton.querySelector('span')?.textContent.trim() || window.variantStrings.addToCart;
      if (this.pending) return;
      const deliverySource = this.product.querySelector('[data-artwork-delivery-source]');
      const deliveryDestination = this.product.querySelector('[data-artwork-delivery-destination]');
      if (deliverySource && deliveryDestination && this.deliverySource !== deliverySource) {
        deliveryDestination.replaceChildren(deliverySource.content.cloneNode(true));
        this.deliverySource = deliverySource;
        for (const guide of this.openGuides || []) {
          this.product.querySelector(`[data-artwork-guide="${guide}"]`)?.setAttribute('open', '');
        }
      }
      const price = this.product.querySelector('.artwork-preview__selection-total strong');
      this.price.textContent = unavailable ? '' : price?.textContent.trim() || '';
      this.selection.textContent = variant && !unavailable ? variant.title.replaceAll(' / ', ' · ') : this.dataset.unavailable;
      this.updateVisibility();
    }
    findOffer() {
      const button = Array.from(document.querySelectorAll('button')).find(node => node !== this.offerButton && /^get\s*10%\s*off$/i.test((node.textContent || node.getAttribute('aria-label') || '').trim()));
      if (!button) {
        this.offerRoot?.classList.remove('artwork-preview__native-offer');
        if (this.offerButton) this.offerButton.hidden = true;
        this.nativeOffer = null;
        return;
      }
      let root = button;
      let floating = null;
      for (let depth = 0; root && root !== document.body && depth < 8; depth++, root = root.parentElement) {
        if (getComputedStyle(root).position === 'fixed' && root.querySelectorAll('button').length <= 3) floating = root;
      }
      if (!floating || !this.offerButton) return;
      this.nativeOffer = button;
      this.offerRoot = floating;
      floating.classList.add('artwork-preview__native-offer');
      this.offerButton.hidden = false;
    }
    updateVisibility() {
      const overlay = document.body.classList.contains('overflow-hidden') || document.querySelector('cart-drawer.active, cart-notification.active, pickup-availability-drawer[open]');
      this.bar.hidden = !this.mobile.matches || !this.optionsReached || this.nativeVisible || !!overlay;
    }
    disconnectedCallback() {
      this.formObserver?.disconnect();
      this.offerObserver?.disconnect();
      this.intersection?.disconnect();
      this.offVariant?.();
      this.offError?.();
      this.mobile?.removeEventListener('change', this.onMedia);
      this.product?.removeEventListener('change', this.onChange);
      this.offerRoot?.classList.remove('artwork-preview__native-offer');
      cancelAnimationFrame(this.syncFrame);
      cancelAnimationFrame(this.offerFrame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["artwork-frame-upgrade"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('artwork-frame-upgrade')) {
  const previousCandyCheck = window.CANDYRACK_CAN_ATC;
  window.CANDYRACK_CAN_ATC = (button) => {
    if (button?.closest('product-form')?.querySelector('artwork-frame-upgrade')) return false;
    return previousCandyCheck ? previousCandyCheck(button) : true;
  };
  customElements.define('artwork-frame-upgrade', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.frameIndex = Number(this.dataset.frameIndex);
      try { this.frameRates = JSON.parse(this.querySelector('[data-frame-rates]').textContent); } catch { this.frameRates = {}; }
      this.dialog = this.querySelector('dialog');
      this.addButton = this.querySelector('[data-frame-add]');
      this.keepButton = this.querySelector('[data-frame-keep]');
      this.error = this.querySelector('[data-frame-error]');
      this.colours = this.querySelector('[data-frame-colours]');
      this.querySelector('[data-frame-close]').addEventListener('click', () => this.finish(null));
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.finish(null); });
      this.dialog.addEventListener('close', () => { if (this.resolve) this.finish(null); });
      this.colours.addEventListener('change', (event) => {
        this.selected = this.offers.find(variant => String(variant.id) === event.target.value);
        this.updatePrice();
      });
      this.addButton.addEventListener('click', () => this.confirm(true));
      this.keepButton.addEventListener('click', () => this.confirm(false));
    }
    isUnframed(value) {
      return /^(?:no\s*frame|un[ -]?framed|print\s*only)/i.test(String(value || '').trim());
    }
    matchingVariants(product, base) {
      return product.variants.filter(variant => variant.available && /^(oak|walnut|black|white)$/i.test(variant.options[this.frameIndex]) && variant.options.every((value, index) => index === this.frameIndex || value === base.options[index]) && variant.price >= base.price).sort((a, b) => ['oak', 'walnut', 'black', 'white'].indexOf(a.options[this.frameIndex].toLowerCase()) - ['oak', 'walnut', 'black', 'white'].indexOf(b.options[this.frameIndex].toLowerCase()));
    }
    async loadProduct() {
      const response = await fetch(`${this.dataset.productUrl}.js`, { cache: 'no-store', signal: AbortSignal.timeout(10000) });
      if (!response.ok) throw new Error(this.dataset.error);
      return response.json();
    }
    async choose(form) {
      const id = form.querySelector('[name="id"]').value;
      const initial = form.closest('[id^="shopify-section-"]')?.querySelector('[data-selected-variant]');
      const current = initial ? JSON.parse(initial.textContent) : null;
      if (current && String(current.id) === id && !this.isUnframed(current.options[this.frameIndex])) return id;
      const product = await this.loadProduct();
      const base = product.variants.find(variant => String(variant.id) === id);
      if (!base?.available) throw new Error(this.dataset.error);
      if (!this.isUnframed(base.options[this.frameIndex])) return id;
      const offers = this.matchingVariants(product, base);
      if (!offers.length) return id;
      this.base = base;
      this.offers = offers;
      this.selected = offers[0];
      this.returnFocus = form.querySelector('[type="submit"]');
      this.querySelector('[data-frame-selection]').textContent = base.options.filter((_, index) => index !== this.frameIndex).join(' · ');
      this.renderColours();
      this.error.hidden = true;
      this.updatePrice();
      this.dialog.showModal();
      this.wasLocked = document.body.classList.contains('overflow-hidden');
      document.body.classList.add('overflow-hidden');
      return new Promise(resolve => { this.resolve = resolve; });
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: this.dataset.currency || 'AUD', minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100);
    }
    renderColours() {
      this.colours.replaceChildren();
      for (const variant of this.offers) {
        const colour = variant.options[this.frameIndex];
        const label = document.createElement('label');
        label.className = 'frame-upgrade__colour';
        label.style.setProperty('--frame-colour', { oak: '#c6a579', walnut: '#684632', black: '#292929', white: '#fff' }[colour.toLowerCase()]);
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = `frame-upgrade-${this.dataset.section}`;
        radio.value = variant.id;
        radio.checked = variant.id === this.selected.id;
        const text = document.createElement('span');
        text.textContent = colour;
        label.append(radio, text);
        this.colours.append(label);
      }
    }
    laterPrice() {
      const rates = this.frameRates?.[this.base.id] || [];
      const colour = this.selected.options[this.frameIndex].toLowerCase();
      const match = rates.find(rate => rate.colour === colour);
      if (match) return match.price;
      if (colour === 'walnut' && rates.length && rates.every(rate => rate.price === rates[0].price)) return rates[0].price;
      return null;
    }
    updatePrice() {
      const extra = this.selected.price - this.base.price;
      const later = this.laterPrice();
      this.querySelector('[data-frame-extra]').textContent = `${this.dataset.extra} +${this.money(extra)}`;
      this.querySelector('[data-frame-comparison]').hidden = !Number.isFinite(later) || later <= extra;
      this.querySelector('[data-frame-later]').textContent = `${this.dataset.later} ${this.money(later || 0)}`;
      this.querySelector('[data-frame-saving]').textContent = `${this.dataset.save} ${this.money(Math.max(0, (later || 0) - extra))}`;
      this.keepButton.textContent = `${this.dataset.keep} — ${this.money(this.base.price)}`;
    }
    async confirm(framed) {
      if (this.confirming) return;
      this.confirming = true;
      this.addButton.disabled = true;
      this.keepButton.disabled = true;
      try {
        const product = await this.loadProduct();
        if (!this.resolve) return;
        const base = product.variants.find(variant => variant.id === this.base.id);
        const target = product.variants.find(variant => variant.id === (framed ? this.selected.id : this.base.id));
        if (!base?.available || !target?.available) throw new Error(this.dataset.error);
        if (base.price !== this.base.price || (framed && target.price !== this.selected.price)) {
          this.base = base;
          this.offers = this.matchingVariants(product, base);
          if (!this.offers.length) throw new Error(this.dataset.error);
          this.selected = this.offers.find(variant => variant.id === this.selected.id) || this.offers[0];
          this.renderColours();
          this.updatePrice();
          this.error.textContent = this.dataset.updated;
          this.error.hidden = false;
          return;
        }
        this.finish(String(target.id));
      } catch {
        this.error.textContent = this.dataset.error;
        this.error.hidden = false;
      } finally {
        this.confirming = false;
        this.addButton.disabled = false;
        this.keepButton.disabled = false;
      }
    }
    finish(id) {
      const resolve = this.resolve;
      this.resolve = null;
      if (this.dialog.open) this.dialog.close();
      if (!this.wasLocked) document.body.classList.remove('overflow-hidden');
      this.returnFocus?.focus({ preventScroll: true });
      resolve?.(id);
    }
    disconnectedCallback() {
      if (this.resolve) this.finish(null);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
